<template>
  <div class="card">
    <div class="title">使用方法</div>
    <div>
      <div class="rich-text">
        <div
          @click="handleUseGuide"
          v-if="selectSku.instruction || selectSku.spu_instruction"
          :key="selectSku.item_code"
          v-replace.day="benefitInfo.coupon_days"
          v-html="selectSku.instruction"
          class="instruction-html"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import copy from "copy-to-clipboard";
import Vue from "vue";

import { jsonSafeParse } from "@/utils";
import { useStore } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  props: ["benefitInfo", "selectSku"],
  setup(props) {
    const store = useStore();

    const isMiniProgram = computed(() => store.state.isMiniProgram);

    const checkUrl = (url) => {
      const MINI_PROGRAM_DOMAIN_WHITE_LIST = jsonSafeParse(
        vm.$getConfigValue("MINI_PROGRAM_DOMAIN_WHITE_LIST") || "[]"
      );
      return MINI_PROGRAM_DOMAIN_WHITE_LIST.some((item) => url.includes(item));
    };

    const handleUseGuide = (event) => {
      const { special_info, product_name } = props.selectSku;
      const target = event.target;
      const linkEl = target.closest("a");
      if (linkEl) {
        // 小程序直接复制链接
        const url = linkEl.getAttribute("href");
        if (isMiniProgram.value && !checkUrl(url)) {
          event.preventDefault();
          copy(url);
          vm.$toast("使用链接已复制，请打开外部浏览器使用");
        }
        // 获取到a标签上的链接
        if (product_name === "瑞鹏宠物") {
          const url = target.getAttribute("href");
          const template_id = JSON.parse(special_info)?.template_id;
          const handleUrl = `${url}?template_id=${template_id}`;
          target.href = handleUrl;
        }
      }
    };

    return {
      handleUseGuide,
    };
  },
});
</script>

<style lang="less" scoped>
.card {
  margin: 12px 12px 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;
}

.title {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.use-method-image {
  margin-top: 12px;
  min-height: 50px;
}

.rich-text {
  color: #777;
  line-height: 22px;
  font-size: 11px;
  img {
    max-width: 100%;
  }
  .instruction-html {
    margin-top: 24px;
  }
}
</style>
